import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { CreateNewIntegrationState } from '../reducers/integration-management-create-new.reducer';
import * as selectors from '../selectors/integration-management-create-new.selectors';

@Injectable()
export class IMCreateNewFacadeService extends FacadeService {
  constructor(public override store: Store<CreateNewIntegrationState>) {
    super(store);
  }

  // OBSERVABLES

  types$ = this.storeSelect(selectors.getIntegrationTypes);
  integrationNameSuffix$ = this.storeSelect(selectors.getIntegrationNameSuffix);
  integrationDescriptionSuffix$ = this.storeSelect(
    selectors.getIntegrationDescriptionSuffix
  );
  showCreateNewIntegrationButtonValue$ = this.storeSelect(
    selectors.getShowCreateNewIntegrationButtonForTypes
  );
  selectedIntegrationType$ = this.storeSelect(
    selectors.getSelectedIntegrationType
  );
  showDetailsTab$ = this.storeSelect(selectors.getShowDetailsTab);
  createNewEnabled$ = this.storeSelect(selectors.getCreateNewEnabled);

  // OBSERVABLE'S VALUES

  get integrationNameSuffix() {
    return this.storeSnapshot(this.integrationNameSuffix$);
  }

  get integrationDescriptionSuffix() {
    return this.storeSnapshot(this.integrationDescriptionSuffix$);
  }

  get selectedIntegrationType() {
    return this.storeSnapshot(this.selectedIntegrationType$);
  }

  get showCreateNewIntegrationButtonValue() {
    return this.storeSnapshot(this.showCreateNewIntegrationButtonValue$);
  }
}
